/**
 * @fileoverview gRPC-Web generated client stub for admin
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as rpc_admin_account_pb from '../../rpc/admin/account_pb';
import * as rpc_admin_davidsons_pb from '../../rpc/admin/davidsons_pb';
import * as rpc_admin_image_pb from '../../rpc/admin/image_pb';
import * as rpc_admin_products_pb from '../../rpc/admin/products_pb';
import * as rpc_admin_rsr_pb from '../../rpc/admin/rsr_pb';
import * as rpc_admin_search_pb from '../../rpc/admin/search_pb';
import * as rpc_admin_sportssouth_pb from '../../rpc/admin/sportssouth_pb';
import * as rpc_admin_suppliers_pb from '../../rpc/admin/suppliers_pb';
import * as rpc_admin_zanders_pb from '../../rpc/admin/zanders_pb';

export class AdminServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoCookie = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_account_pb.CookieResponse,
    (request: rpc_admin_account_pb.CookieRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_account_pb.CookieResponse.deserializeBinary
  );

  cookie(
    request: rpc_admin_account_pb.CookieRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_account_pb.CookieResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/Cookie',
      request,
      metadata || {},
      this.methodInfoCookie,
      callback);
  }

  methodInfoClearCookie = new grpcWeb.AbstractClientBase.MethodInfo(
    google_protobuf_empty_pb.Empty,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  clearCookie(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: google_protobuf_empty_pb.Empty) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/ClearCookie',
      request,
      metadata || {},
      this.methodInfoClearCookie,
      callback);
  }

  methodInfoToken = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_account_pb.TokenResponse,
    (request: rpc_admin_account_pb.TokenRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_account_pb.TokenResponse.deserializeBinary
  );

  token(
    request: rpc_admin_account_pb.TokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_account_pb.TokenResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/Token',
      request,
      metadata || {},
      this.methodInfoToken,
      callback);
  }

  methodInfoDavidsonsSearch = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.SearchResponse,
    (request: rpc_admin_search_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.SearchResponse.deserializeBinary
  );

  davidsonsSearch(
    request: rpc_admin_search_pb.SearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.SearchResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/DavidsonsSearch',
      request,
      metadata || {},
      this.methodInfoDavidsonsSearch,
      callback);
  }

  methodInfoDavidsonsAutocomplete = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.AutocompleteResponse,
    (request: rpc_admin_search_pb.AutocompleteRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.AutocompleteResponse.deserializeBinary
  );

  davidsonsAutocomplete(
    request: rpc_admin_search_pb.AutocompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.AutocompleteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/DavidsonsAutocomplete',
      request,
      metadata || {},
      this.methodInfoDavidsonsAutocomplete,
      callback);
  }

  methodInfoGetDavidsonsProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_davidsons_pb.DavidsonsProduct,
    (request: rpc_admin_davidsons_pb.GetDavidsonsProductRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_davidsons_pb.DavidsonsProduct.deserializeBinary
  );

  getDavidsonsProduct(
    request: rpc_admin_davidsons_pb.GetDavidsonsProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_davidsons_pb.DavidsonsProduct) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetDavidsonsProduct',
      request,
      metadata || {},
      this.methodInfoGetDavidsonsProduct,
      callback);
  }

  methodInfoProductSearch = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.SearchResponse,
    (request: rpc_admin_search_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.SearchResponse.deserializeBinary
  );

  productSearch(
    request: rpc_admin_search_pb.SearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.SearchResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/ProductSearch',
      request,
      metadata || {},
      this.methodInfoProductSearch,
      callback);
  }

  methodInfoProductAutocomplete = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.AutocompleteResponse,
    (request: rpc_admin_search_pb.AutocompleteRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.AutocompleteResponse.deserializeBinary
  );

  productAutocomplete(
    request: rpc_admin_search_pb.AutocompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.AutocompleteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/ProductAutocomplete',
      request,
      metadata || {},
      this.methodInfoProductAutocomplete,
      callback);
  }

  methodInfoGetProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_products_pb.GetProductResponse,
    (request: rpc_admin_products_pb.GetProductRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_products_pb.GetProductResponse.deserializeBinary
  );

  getProduct(
    request: rpc_admin_products_pb.GetProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_products_pb.GetProductResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetProduct',
      request,
      metadata || {},
      this.methodInfoGetProduct,
      callback);
  }

  methodInfoSaveProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_products_pb.Product,
    (request: rpc_admin_products_pb.SaveProductRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_products_pb.Product.deserializeBinary
  );

  saveProduct(
    request: rpc_admin_products_pb.SaveProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_products_pb.Product) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/SaveProduct',
      request,
      metadata || {},
      this.methodInfoSaveProduct,
      callback);
  }

  methodInfoDeleteProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    google_protobuf_empty_pb.Empty,
    (request: rpc_admin_products_pb.DeleteProductRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteProduct(
    request: rpc_admin_products_pb.DeleteProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: google_protobuf_empty_pb.Empty) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/DeleteProduct',
      request,
      metadata || {},
      this.methodInfoDeleteProduct,
      callback);
  }

  methodInfoUploadProductImage = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_image_pb.Image,
    (request: rpc_admin_products_pb.UploadProductImageRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_image_pb.Image.deserializeBinary
  );

  uploadProductImage(
    request: rpc_admin_products_pb.UploadProductImageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_image_pb.Image) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/UploadProductImage',
      request,
      metadata || {},
      this.methodInfoUploadProductImage,
      callback);
  }

  methodInfoGenerateProductId = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_products_pb.GenerateProductIdResponse,
    (request: rpc_admin_products_pb.GenerateProductIdRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_products_pb.GenerateProductIdResponse.deserializeBinary
  );

  generateProductId(
    request: rpc_admin_products_pb.GenerateProductIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_products_pb.GenerateProductIdResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GenerateProductId',
      request,
      metadata || {},
      this.methodInfoGenerateProductId,
      callback);
  }

  methodInfoRsrSearch = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.SearchResponse,
    (request: rpc_admin_search_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.SearchResponse.deserializeBinary
  );

  rsrSearch(
    request: rpc_admin_search_pb.SearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.SearchResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/RsrSearch',
      request,
      metadata || {},
      this.methodInfoRsrSearch,
      callback);
  }

  methodInfoRsrAutocomplete = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.AutocompleteResponse,
    (request: rpc_admin_search_pb.AutocompleteRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.AutocompleteResponse.deserializeBinary
  );

  rsrAutocomplete(
    request: rpc_admin_search_pb.AutocompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.AutocompleteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/RsrAutocomplete',
      request,
      metadata || {},
      this.methodInfoRsrAutocomplete,
      callback);
  }

  methodInfoGetRsrProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_rsr_pb.RsrProduct,
    (request: rpc_admin_rsr_pb.GetRsrProductRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_rsr_pb.RsrProduct.deserializeBinary
  );

  getRsrProduct(
    request: rpc_admin_rsr_pb.GetRsrProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_rsr_pb.RsrProduct) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetRsrProduct',
      request,
      metadata || {},
      this.methodInfoGetRsrProduct,
      callback);
  }

  methodInfoSportsSouthSearch = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.SearchResponse,
    (request: rpc_admin_search_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.SearchResponse.deserializeBinary
  );

  sportsSouthSearch(
    request: rpc_admin_search_pb.SearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.SearchResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/SportsSouthSearch',
      request,
      metadata || {},
      this.methodInfoSportsSouthSearch,
      callback);
  }

  methodInfoSportsSouthAutocomplete = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.AutocompleteResponse,
    (request: rpc_admin_search_pb.AutocompleteRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.AutocompleteResponse.deserializeBinary
  );

  sportsSouthAutocomplete(
    request: rpc_admin_search_pb.AutocompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.AutocompleteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/SportsSouthAutocomplete',
      request,
      metadata || {},
      this.methodInfoSportsSouthAutocomplete,
      callback);
  }

  methodInfoGetSportsSouthProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_sportssouth_pb.SportsSouthProduct,
    (request: rpc_admin_sportssouth_pb.GetSportsSouthProductRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_sportssouth_pb.SportsSouthProduct.deserializeBinary
  );

  getSportsSouthProduct(
    request: rpc_admin_sportssouth_pb.GetSportsSouthProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_sportssouth_pb.SportsSouthProduct) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetSportsSouthProduct',
      request,
      metadata || {},
      this.methodInfoGetSportsSouthProduct,
      callback);
  }

  methodInfoSupplierSearch = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.SearchResponse,
    (request: rpc_admin_search_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.SearchResponse.deserializeBinary
  );

  supplierSearch(
    request: rpc_admin_search_pb.SearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.SearchResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/SupplierSearch',
      request,
      metadata || {},
      this.methodInfoSupplierSearch,
      callback);
  }

  methodInfoSupplierAutocomplete = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.AutocompleteResponse,
    (request: rpc_admin_search_pb.AutocompleteRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.AutocompleteResponse.deserializeBinary
  );

  supplierAutocomplete(
    request: rpc_admin_search_pb.AutocompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.AutocompleteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/SupplierAutocomplete',
      request,
      metadata || {},
      this.methodInfoSupplierAutocomplete,
      callback);
  }

  methodInfoGetSupplierInventories = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_suppliers_pb.GetSupplierInventoriesResponse,
    (request: rpc_admin_suppliers_pb.GetSupplierInventoriesRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_suppliers_pb.GetSupplierInventoriesResponse.deserializeBinary
  );

  getSupplierInventories(
    request: rpc_admin_suppliers_pb.GetSupplierInventoriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_suppliers_pb.GetSupplierInventoriesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetSupplierInventories',
      request,
      metadata || {},
      this.methodInfoGetSupplierInventories,
      callback);
  }

  methodInfoGetSupplierHistory = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_suppliers_pb.SupplierHistoryResponse,
    (request: rpc_admin_suppliers_pb.SupplierHistoryRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_suppliers_pb.SupplierHistoryResponse.deserializeBinary
  );

  getSupplierHistory(
    request: rpc_admin_suppliers_pb.SupplierHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_suppliers_pb.SupplierHistoryResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetSupplierHistory',
      request,
      metadata || {},
      this.methodInfoGetSupplierHistory,
      callback);
  }

  methodInfoZandersSearch = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.SearchResponse,
    (request: rpc_admin_search_pb.SearchRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.SearchResponse.deserializeBinary
  );

  zandersSearch(
    request: rpc_admin_search_pb.SearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.SearchResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/ZandersSearch',
      request,
      metadata || {},
      this.methodInfoZandersSearch,
      callback);
  }

  methodInfoZandersAutocomplete = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_search_pb.AutocompleteResponse,
    (request: rpc_admin_search_pb.AutocompleteRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_search_pb.AutocompleteResponse.deserializeBinary
  );

  zandersAutocomplete(
    request: rpc_admin_search_pb.AutocompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_search_pb.AutocompleteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/ZandersAutocomplete',
      request,
      metadata || {},
      this.methodInfoZandersAutocomplete,
      callback);
  }

  methodInfoGetZandersProduct = new grpcWeb.AbstractClientBase.MethodInfo(
    rpc_admin_zanders_pb.ZandersProduct,
    (request: rpc_admin_zanders_pb.GetZandersProductRequest) => {
      return request.serializeBinary();
    },
    rpc_admin_zanders_pb.ZandersProduct.deserializeBinary
  );

  getZandersProduct(
    request: rpc_admin_zanders_pb.GetZandersProductRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: rpc_admin_zanders_pb.ZandersProduct) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/admin.AdminService/GetZandersProduct',
      request,
      metadata || {},
      this.methodInfoGetZandersProduct,
      callback);
  }

}

